import React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';
import { Button } from '@lightspeed/flame/Button';
import axios from 'axios';
import { Field, withFormik } from 'formik';
import get from 'lodash/get';
import * as Yup from 'yup';

import Input from 'pages/components/Formik/Input';

const PublishLimitModal = ({ handleSubmit, isSubmitting, onClose }) => (
  <Modal className="cirrus" isOpen onRequestClose={() => onClose()}>
    <ModalHeader onCloseClicked={() => onClose()}>Publish to eCom Item Limit</ModalHeader>
    <ModalBody>
      <Text body color="gray">
        <strong>WARNING</strong>: Differing limits in Retail and eCom will prevent items from being
        published to eCom.
      </Text>
      <ul className="cr-mv-4">
        <li>
          <Text body color="gray">
            Step 1: Update the eCom total item limit. Follow the{' '}
            <a
              href="https://lightspeedhq.atlassian.net/wiki/x/loZPC"
              target="_blank"
              rel="noopener noreferrer"
            >
              request limit increase process
            </a>
            .
          </Text>
        </li>
        <li>
          <Text body color="gray">
            Step 2: In this window, change the item limit to the new value. Both limits must be
            equal.
          </Text>
        </li>
      </ul>
      <form onSubmit={handleSubmit}>
        <Field
          label="Publish to eCom Item Limit"
          component={Input}
          required
          name="publishLimit"
          type="number"
          autoFocus
        />
      </form>
    </ModalBody>
    <ModalFooter>
      <Group className="cr-justify-end">
        <Button onClick={() => onClose()}>Cancel</Button>
        <Button variant="secondary" fill loading={isSubmitting} onClick={handleSubmit}>
          I understand. Save Item Limit
        </Button>
      </Group>
    </ModalFooter>
  </Modal>
);

const enhancedPublishLimitModal = withFormik({
  mapPropsToValues: (props) => ({
    publishLimit: get(props, 'publishLimit', ''),
  }),
  validationSchema: () => {
    const min = 0;
    const max = 100000;

    return Yup.object().shape({
      publishLimit: Yup.number()
        .required(`Enter a limit between ${min} and ${max}`)
        .min(min, `Item Limit can't be lower than ${min}`)
        .max(max, `Item Limit can't be greater than ${max}`)
        .integer('Item Limit needs to be an integer'),
    });
  },
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId } = formikBag.props;
    const { publishLimit } = values;

    try {
      await axios.put(`/staff/accounts/${accountId}/ecom/publish_limit`, {
        data: {
          ecom: {
            publish_limit: publishLimit,
          },
        },
      });
      formikBag.props.onConfirm({ updateData: true });
    } catch (e) {
      window.alertUser(get(e, 'response.data.errors[0].detail') || 'An error occurred');
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose();
  },
})(PublishLimitModal);

export default enhancedPublishLimitModal;
